import { AppVersionProps } from './types';
import s from './index.module.scss';

export const AppVersion = ({ color }: AppVersionProps) => {
  const version = import.meta.env.VITE_APP_VERSION || '';
  const release = import.meta.env.VITE_RELEASE || '';

  if (!version) return null;

  return (
    <div className={s.version} style={{ color }}>
      App version: {version}-{release?.charAt(0)}
    </div>
  );
};
